import type { Spread } from '../types';
import raw from './spreads.json';

export const spreads: Spread[] = raw as Spread[];
export const spreadById = new Map<string, Spread>(spreads.map((s) => [s.id, s]));
